interface PostObject {
  endpoint: string;
  payload?: object;
  headers?: object;
}

export const post = async ({ endpoint, payload, headers }: PostObject) => {
  return await fetch(`${process.env.NEXT_PUBLIC_API_DOMAIN}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
};
